<template>
  <div class="order-list-container">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
    ></admin-filter>

    <div class="columns">
      <div class="column is-full">
        <div class="flex-end" style="gap:12px">
          <button class="button is-gray btn-download" @click="clickDown('order')">
            <i class="material-icons">cloud_download</i>주문신청내역 (xlsx)</button>
          <template v-if="$route.path.indexOf('order_list_request')>-1">
            <button class="button is-gray btn-download" @click="clickDown('invoice')">
                <i class="material-icons">cloud_download</i>인보이스 입력 (xlsx)</button>
            <button-upload label="인보이스" uploadType="invoice" @upload="getDataFromServer"></button-upload>
          </template>
          <template v-if="$route.path.indexOf('order_list_pay_done')>-1">
            <button class="button is-gray btn-download" @click="clickDown('tracking')">
              <i class="material-icons">cloud_download</i>송장번호 입력 (xlsx)</button>
            <button-upload label="송장번호" uploadType="tracking" @upload="getDataFromServer"></button-upload>
          </template>
        </div>
      </div>
    </div>

    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @check="clickCheckBox"
                 @checkItem="res => checkArr[res].value = !checkArr[res].value"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <td slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>
      <td slot="created_time" slot-scope="props">{{ props.item.created_time }}</td>
      <td slot="order_type_kor" slot-scope="props">{{ props.item.order_type_kor }}</td>
      <td slot="status_kor" slot-scope="props">{{props.item.status_kor }}</td>
      <td slot="reference_no" slot-scope="props">
        <router-link style="text-decoration: underline"
          :to="`order_detail?id=${props.item.id}`">{{ props.item.reference_no }}</router-link>
      </td>
      <td slot="user_name" slot-scope="props">{{props.item.user.last_name }}{{ props.item.user.name }}</td>
      <td slot="info_name" slot-scope="props">{{ infoName(props.item) }}</td>
      <td slot="email" slot-scope="props">{{props.item.user.email }}</td>
      <td slot="point" slot-scope="props">{{props.item.point|currencyNum }}</td>
      <td slot="invoice_price" slot-scope="props">{{ props.item.invoice ? props.item.invoice.price : '-' }}</td>
      <td slot="invoice_price_won" slot-scope="props">{{ props.item.invoice ? currencyNum(props.item.invoice.price_won) : '-' }}</td>
      <td slot="invoice_num" slot-scope="props">{{ props.item.invoice ? props.item.invoice.invoice_number : '-' }}</td>
      <!-- 인보이스 파일-->
      <td slot="file" slot-scope="props">
        <div class="flex-center" style="gap:8px" v-if="props.item.invoice && props.item.invoice.file" >
          <a :href="props.item.invoice.file" target="_blank">
            {{ props.item.invoice.file ? props.item.invoice.file.split('/').slice(-1)[0] : '-' }}
          </a>
          <div class="btn-delete unselect" @click.stop.prevent="clickDelInvoice(props.item.invoice)">
            <i class="material-icons">close</i>
          </div>
        </div>
        <div v-else class="flex-center">
          <button-invoice v-if="$route.path.indexOf('france')>-1" :item="props.item"></button-invoice>
          <button-upload v-else label="" uploadType="invoice_file" :invoice="props.item.invoice"
          @upload="e => props.item.invoice.file = e"></button-upload>
        </div>
      </td>
      <td slot="parcel_number" slot-scope="props">
        <div v-for="(info,idx) in props.item.info" :key="`hawb-${idx}`">
          {{ info.parcel_number && info.parcel_number !== '' ? info.parcel_number : '-' }}</div>
      </td>

      <td slot="insurance_sign" slot-scope="props">{{props.item.insurance_sign ? '가입' : '가입안함' }}</td>
      <td slot="disclaim" slot-scope="props">{{props.item.disclaim ? '동의' : '동의안함' }}</td>

      <div slot="spot" v-if="status_arr.length>0">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status = Number(e.target.value)">
              <option value="" disabled selected>진행 상태</option>
              <option :value="item.value" v-for="(item, idx) in status_arr"
                      :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px"
                  @click="clickChange">일괄처리
          </button>
        </div>
      </div>
    </order-table>
  </div>
</template>

<script>
  import ShipAgencyMixin from "../../../mixins/ShipAgencyMixin";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import ButtonUpload from "./components/ButtonUpload";
  import ButtonInvoice from "./components/ButtonInvoice";

  export default {
    name: "OrderList",
    mixins: [
      ShipAgencyMixin
    ],
    components: {
      ButtonInvoice,
      ButtonUpload,
      LpCheckBool
    },
    created() {
      this.init();
    },
    data() {
      return {
        status: 100
      }
    },
    watch: {
      '$route'(n, o) {
        /*if(n.path !== o.path) {
          this.initFiltered();
        }*/
      }
    },
    methods: {
      init() {
        this.status = {
          all: 0,
          request: 100,
          pay_req: 101,
          pay_done: 102,
          shipping: 103,
          done: 104,
          cancel: 500
        }[this.$route.path.split('ship_agency/order_list_').slice(-1)[0]];
        this.initializing('ship_agency_order', `shipagency/${this.$route.path.indexOf('france')>-1 ? 'fr' : 'de'}/order`, this.status)
      },
      infoName(item) {
        return item.info.map(i => i.name).toString();
      },
      clickDown(key) {
        let ids = this.getCheckedArr();
        let params =this.filtered;
        if(ids.length>0) {
          params = {
            ids: ids.toString()
          }
        } else {
          this.toast('다운로드할 항목을 먼저 체크해주세요.');
          return;
        }
        params.country = this.$route.path.indexOf('france') > -1 ? 'fr' : 'de';
        let ext = 'xlsx';
        if(key === 'order') {
          ext = 'xls';
        }

        this.$axios.get(`admin/shipagency/download/xlsx/${key}`, {
          responseType: 'arraybuffer',
          params: params
        }).then(res => {
          const blob = new Blob([res.data], {type: `application/${ext}`});
          const blobURL = window.URL.createObjectURL(blob);
          const tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute('download', `${key}_${this.moment().format('YYYYMMDDHHmm')}.${ext}`);
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        });
      },
      clickDelInvoice(item) {
        if(confirm('인보이스 파일을 삭제 하시겠습니까?')) {
          this.$axios.patch(`admin/shipagency/invoice/${item.id}`, {file: null}).then(res => {
            if(res.status === 200) {
              item.file = null;
            }
          });
        }
      },
      getDataFromServer() {
        this.getData();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .btn-download
    width fit-content
    display flex
    align-items center
    gap 8px
  .btn-delete
    width 18px
    height 18px
    border 1px solid #ddd
    border-radius 100%
    display flex
    align-items center
    justify-content center
    i
      font-size 13px
  .btn-delete:hover
    background-color #f5f5f5
  td
    word-break break-all
</style>
